import React from 'react';
import { Container } from 'react-bootstrap';
import ElectionIssues from '~/helpers/constants/ElectionIssues';

import { PopGrid } from '@australiangreens/components';
/**
 * Component for the 2026 SA "Why Vote Green" section.
 */
export const SA26WVG = ({ electorate }) => {
  if(electorate == "Heysen") {
    return <>
      <Container>
        <h1>A strong voice for Heysen is closer than you think.</h1>
        <h2>Change comes from communities like this, voting for better.</h2>

        <p>This community cares deeply for the environment, and one another, but all too often our voices aren't heard when it comes to decisions that impact us. Together, we can fix that. </p>

        <p><strong>The Greens can win in Heysen.</strong> With Labor heading for a landslide win, the question isn't who governs - it's who holds them accountable. One party calling all the shots is bad for our community.</p>

        <p><strong>A vote for Greens in Heysen means Labor isn't handed a blank cheque.</strong></p>

        <h2>THE GREENS ARE STANDING UP FOR THE HILLS</h2>

        <PopGrid tiles={ElectionIssues.sa26alt} rowSize={2} />

      </Container>
    </>
  }
  return <>
    <Container>
      <h1>If you want change, you have to vote for it.</h1>
      <h2>LIVING IN SA SHOULDN'T COST YOU THE EARTH.</h2>

      <p>South Australia has always been known for our easygoing way of life. But lately, that couldn't feel further from the truth.</p>

      <p>It shouldn't be this tough to afford the basics. Corporations definitely shouldn't be making record profits while everyday people are struggling to make ends meet.</p>

      <p><strong>If you want change, you have to vote for it.</strong></p>
      <p>Labor is on track to win by a landslide. Voting #1 Greens is our chance to do better for all South Australians.</p>
      <p>The Greens are pushing to make sure everybody is able to afford the things we need to live, and to protect the things we care about most.</p>

      <p>The Greens are pushing to make sure everybody is able to afford the basics, and to protect the things we care about most.</p>
      <h2>THE GREENS ARE PUSHING FOR</h2>

      <PopGrid tiles={ElectionIssues.sa26} rowSize={2} />

    </Container>
  </>
}

export default SA26WVG;
